/* eslint-disable */
// @ts-nocheck

import { OrbType } from '@data/types';
import classNames from 'classnames';
import React, { Fragment, useEffect, useRef } from 'react';

interface Props extends OrbType {}

const Orb: React.FC<Props> = ({
  pillarIndex = 0,
  questionIndex = 0,
  className = '',
  videoClassName = '',
}) => {
  const videos = [
    'Pillar 01_1_500.mp4',
    'Pillar 02_1_500.mp4',
    'Pillar 03_1_500.mp4',
    'Pillar 04_1_500.mp4',
    'Pillar 05_1_500.mp4',
    'Pillar 06_1_500.mp4',
  ];

  const colors = [
    [255, 255, 255],
    [179, 201, 236],
    [184, 160, 217],
    [188, 118, 199],
    [193, 77, 180],
    [197, 35, 161],
  ];

  const container = useRef();
  const canvas = useRef();
  const _index = useRef(pillarIndex);

  const scale = 0.5;
  const factor = 500 * scale;

  useEffect(function () {
    const ctx = canvas.current.getContext('2d');

    const elements = [...container.current.querySelectorAll('[data-instance]')];
    const instances = elements.map((element) => {
      const videoElement = element.querySelector('video');
      const canvas = element.querySelector('canvas');
      const context = canvas.getContext('2d', {
        willReadFrequently: true,
      });

      return {
        videoElement,
        canvas,
        context,
      };
    });

    (function draw() {
      ctx.clearRect(0, 0, factor, factor);

      instances.forEach(({ videoElement, canvas, context }, __index) => {
        if (__index < _index.current) {
          context.drawImage(videoElement, 0, 0, factor, factor);
          const imageData = context.getImageData(0, 0, factor, factor);

          for (let index = 0; index < imageData.data.length; index += 4) {
            const alpha =
              (imageData.data[index] +
                imageData.data[index + 1] +
                imageData.data[index + 2]) /
              3;
            imageData.data[index] = colors[__index][0];
            imageData.data[index + 1] = colors[__index][1];
            imageData.data[index + 2] = colors[__index][2];
            imageData.data[index + 3] = Math.floor(alpha);
          }

          context.putImageData(imageData, 0, 0);
          ctx.drawImage(canvas, 0, 0, factor, factor);
        }
      });

      setTimeout(draw, 1000 / 12);
    })();
  }, []);

  useEffect(
    function () {
      _index.current = pillarIndex;
    },
    [pillarIndex]
  );

  return (
    <div className={classNames('absolute inset-8', className)}>
      <span className="sr-only">
        {pillarIndex} — {questionIndex}
      </span>
      <div className="absolute top-0 left-0 opacity-0" ref={container}>
        {videos.map((video, index) => (
          <div className="absolute top-0 left-0" key={index} data-instance>
            <video
              className="w-12"
              src={require(`@assets/videos/${video}`)}
              muted
              autoPlay
              loop
              playsInline
            />
            <canvas className="w-12" width={factor} height={factor} />
          </div>
        ))}
      </div>
      <canvas
        className={classNames(
          'blur-[1px] absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 block w-full h-full object-center object-contain max-w-[225px] max-h-[225px] md:max-w-[350px] md:max-h-[350px]',
          videoClassName
        )}
        width={factor}
        height={factor}
        ref={canvas}
        data-canvas-main
      />
    </div>
  );
};

export default Orb;
